import { RequestHandler } from 'express';

import { mockingMiddleware } from './mockingMiddleware';

import { mapBodyToPayload } from '~/transformations/mapBodyToPayload';
import { mapPayloadToMigrateOperations } from '~/transformations/mapPayloadToMigrateOperations';

import { Logger } from '~/util/logger';
import mapErrorToObject from '~/transformations/mapAppErrorToObject';

export const useMockData = mockingMiddleware();

export const parsePayload: RequestHandler = (req, res, next) => {
  const preview =
    req.params.preview !== 'commit' && !req.originalUrl.includes('/commit');

  if (Object.keys(req.body || {}).length === 0) {
    const parseError = new Error(
      `Unable to parse body, did you include the "content-type: application/json" header?`
    );
    res.setHeader('expose-raw-errors', 'true');
    res.status(500).send(mapErrorToObject(parseError));
    Logger.error(parseError.message);
    return;
  }

  const payload = mapBodyToPayload(req.body);

  Logger.success(
    `${preview ? 'Preview' : 'Commit'} request to '${req.originalUrl}'`,
    true
  );

  const { source, target, query, zenQL } = payload;

  const sourceAlias = source?.url
    .split('.')?.[0]
    .split('//')?.[1]
    ?.replace('cms-', '');
  const targetAlias = target?.url
    .split('.')?.[0]
    .split('//')?.[1]
    ?.replace('cms-', '');

  // Check for id in url params
  const idParam =
    req.params.id ||
    req.params.modelId ||
    req.params.contentTypeId ||
    req.params.componentId;

  Logger.success(
    `Parsed environment JSON for migration:${
      source
        ? `
 from <${source?.project}> in ${sourceAlias}`
        : ''
    }
   to <${target?.targetProjects?.join(', ')}> in ${
      target?.targetProjects && targetAlias
    }${
      target?.syncProjects
        ? `
 sync <${target.syncProjects?.join(', ')}> in ${
            target.syncProjects && targetAlias
          }`
        : ''
    }${
      query
        ? `
query <${JSON.stringify(query)}>`
        : ''
    }${
      zenQL
        ? `
zenQL <${zenQL}>`
        : ''
    }
    `,
    true
  );
  // Download assets when committing or the preview param is download
  res.locals.payload = payload;
  res.locals.preview = preview;
  res.locals.download = !preview || req.params.preview === 'download';
  res.locals.id = idParam;
  res.locals.operations = mapPayloadToMigrateOperations(payload);
  res.locals.entity = req.params.entity;
  useMockData(req, res, next);
  // next();
};
